import {
  initialState,
  Actions,
  State,
  GET_ALL_CONTACTS,
  GET_ALL_CONTACTS_SUCCESS,
  GET_ALL_CONTACTS_ERROR,
  RESET_GET_ALL_CONTACTS,
  UPDATE_CONTACTS,
} from '../../types/contact/get-all'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_CONTACTS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ALL_CONTACTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ALL_CONTACTS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case UPDATE_CONTACTS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: false,
        },
      }
    case RESET_GET_ALL_CONTACTS:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
